import request from '@/utils/request'

// 院校列表

let SchoolParamsApi = {

    /*列表*/
    getList(data, errorback) {
        return request._post('/shop/study.schoolParams/index', data, errorback);
    },

    /*添加*/
    add(data, errorback) {
        return request._post('/shop/study.schoolParams/add', data, errorback);
    },

    /*删除*/
    del(data, errorback) {
        return request._post('/shop/study.schoolParams/del', data, errorback);
    },

    /*编辑*/
    edit(data, errorback) {
        return request._post('/shop/study.schoolParams/edit', data, errorback);
    },

    /*批量操作*/
    batch(data, errorback) {
        return request._post('/shop/study.schoolParams/batch', data, errorback);
    },
}

export default SchoolParamsApi;



// WEBPACK FOOTER //
// ./src/api/study/school_params.js